import { useMountEffect } from "@companion-core/shared/app/Hooks/useMountEffect";
import { useHeaderStore } from "@companion-core/shared/app/Store/header";

export const useRecommendedListHeader = () => {
  const { setDisabledHeader } = useHeaderStore();

  useMountEffect(() => {
    setDisabledHeader(true);
    return () => {
      setDisabledHeader(false);
    };
  });
};
